/**
 * 30 High Quality Curated Couple & Relationship Images for Covers & Articles
 */
export const PLACEHOLDER_IMAGES = [
  {
    id: 1,
    title: 'Cozy Morning Coffee Together',
    url: 'https://images.unsplash.com/photo-1542338332-76971ae8c292?auto=format&fit=crop&w=1200&q=80',
    category: 'Daily Routine',
  },
  {
    id: 2,
    title: 'Walking Hand in Hand at Sunset',
    url: 'https://images.unsplash.com/photo-1575388104683-e076ee9ccaa0?auto=format&fit=crop&w=1200&q=80',
    category: 'Romantic Walks',
  },
  {
    id: 3,
    title: 'Couple Laughing on the Sofa',
    url: 'https://images.unsplash.com/photo-1655759738595-418970010986?auto=format&fit=crop&w=1200&q=80',
    category: 'Communication',
  },
  {
    id: 4,
    title: 'Romantic Candlelight Dinner',
    url: 'https://images.unsplash.com/photo-1542557497-4c7b03d0d245?auto=format&fit=crop&w=1200&q=80',
    category: 'Date Ideas',
  },
  {
    id: 5,
    title: 'Couple Cooking Dinner in Kitchen',
    url: 'https://images.unsplash.com/photo-1556911261-6bd341186b2f?auto=format&fit=crop&w=1200&q=80',
    category: 'Acts of Service',
  },
  {
    id: 6,
    title: 'Holding Hands Close Up',
    url: 'https://images.unsplash.com/photo-1541679368093-5c967ac6de11?auto=format&fit=crop&w=1200&q=80',
    category: 'Intimacy',
  },
  {
    id: 7,
    title: 'Picnic in the Park',
    url: 'https://images.unsplash.com/photo-1630276740239-5d9c23d49531?auto=format&fit=crop&w=1200&q=80',
    category: 'Quality Time',
  },
  {
    id: 8,
    title: 'Deep Honest Conversation',
    url: 'https://images.unsplash.com/photo-1713942590288-1468a2d88ee4?auto=format&fit=crop&w=1200&q=80',
    category: 'Conflict Resolution',
  },
  {
    id: 9,
    title: 'Surprise Gift & Flowers',
    url: 'https://images.unsplash.com/photo-1455819413567-ef04b7e1fe3d?auto=format&fit=crop&w=1200&q=80',
    category: 'Receiving Gifts',
  },
  {
    id: 10,
    title: 'Road Trip Adventure Together',
    url: 'https://images.unsplash.com/photo-1529424601215-d2a3daf193ff?auto=format&fit=crop&w=1200&q=80',
    category: 'Adventure',
  },
  {
    id: 11,
    title: 'Warm Hug & Embrace',
    url: 'https://images.unsplash.com/photo-1499568509606-4f9b771232ed?auto=format&fit=crop&w=1200&q=80',
    category: 'Physical Touch',
  },
  {
    id: 12,
    title: 'Writing Love Notes',
    url: 'https://images.unsplash.com/photo-1594320207823-405209d4a92b?auto=format&fit=crop&w=1200&q=80',
    category: 'Words of Affirmation',
  },
  {
    id: 13,
    title: 'Stargazing by Night',
    url: 'https://images.unsplash.com/photo-1700157526583-ba6da7821656?auto=format&fit=crop&w=1200&q=80',
    category: 'Romantic Date',
  },
  {
    id: 14,
    title: 'Morning Cuddle in Bed',
    url: 'https://images.unsplash.com/photo-1514480100661-33506ca03fe7?auto=format&fit=crop&w=1200&q=80',
    category: 'Connection',
  },
  {
    id: 15,
    title: 'Sharing Secrets & Whispers',
    url: 'https://images.unsplash.com/photo-1619208110262-90c0438c174d?auto=format&fit=crop&w=1200&q=80',
    category: 'Trust',
  },
  {
    id: 16,
    title: 'Dancing Together in the Living Room',
    url: 'https://images.unsplash.com/photo-1758525864630-0ae453e0e44c?auto=format&fit=crop&w=1200&q=80',
    category: 'Fun & Play',
  },
  {
    id: 17,
    title: 'Planning Future & Calendar',
    url: 'https://images.unsplash.com/photo-1554902748-79535dbf5ff7?auto=format&fit=crop&w=1200&q=80',
    category: 'Shared Goals',
  },
  {
    id: 18,
    title: 'Couple Celebrating an Anniversary',
    url: 'https://images.unsplash.com/photo-1773040835767-2a2b6ff87b23?auto=format&fit=crop&w=1200&q=80',
    category: 'Milestones',
  },
  {
    id: 19,
    title: 'Relaxing Beach Walk',
    url: 'https://images.unsplash.com/photo-1747419003011-97b50122a653?auto=format&fit=crop&w=1200&q=80',
    category: 'Getaway',
  },
  {
    id: 20,
    title: 'Heartfelt Apology & Making Up',
    url: 'https://images.unsplash.com/photo-1758524944637-a515455f95ec?auto=format&fit=crop&w=1200&q=80',
    category: 'Conflict Resolution',
  },
  {
    id: 21,
    title: 'Couple Sharing Ice Cream / Treats',
    url: 'https://images.unsplash.com/photo-1652550118215-16a41e067804?auto=format&fit=crop&w=1200&q=80',
    category: 'Sweet Moments',
  },
  {
    id: 22,
    title: 'Movie Night & Popcorn',
    url: 'https://images.unsplash.com/photo-1608170825938-a8ea0305d46c?auto=format&fit=crop&w=1200&q=80',
    category: 'Date Night',
  },
  {
    id: 23,
    title: 'Couple Working from Home Side by Side',
    url: 'https://images.unsplash.com/photo-1758522490571-a0002f7377d6?auto=format&fit=crop&w=1200&q=80',
    category: 'Daily Balance',
  },
  {
    id: 24,
    title: 'Couple Doing Yoga / Mindful Rest',
    url: 'https://images.unsplash.com/photo-1603792582751-c73976204e1e?auto=format&fit=crop&w=1200&q=80',
    category: 'Wellness',
  },
  {
    id: 25,
    title: 'Cozy Fireplace Reading',
    url: 'https://images.unsplash.com/photo-1582894535021-f875b7d0c4ea?auto=format&fit=crop&w=1200&q=80',
    category: 'Cozy Vibes',
  },
  {
    id: 26,
    title: 'Expressing Appreciation & Praise',
    url: 'https://images.unsplash.com/photo-1501901609772-df0848060b33?auto=format&fit=crop&w=1200&q=80',
    category: 'Brownie Points',
  },
  {
    id: 27,
    title: 'Exploring an Art Museum Together',
    url: 'https://images.unsplash.com/photo-1706320291927-ea5b107db646?auto=format&fit=crop&w=1200&q=80',
    category: 'Culture & Dates',
  },
  {
    id: 28,
    title: 'Scenic Mountain Hike as a Pair',
    url: 'https://images.unsplash.com/photo-1627551885247-f9301e1d6101?auto=format&fit=crop&w=1200&q=80',
    category: 'Active Romance',
  },
  {
    id: 29,
    title: 'Sparklers & Celebration',
    url: 'https://images.unsplash.com/photo-1514845505178-849cebf1a91d?auto=format&fit=crop&w=1200&q=80',
    category: 'Celebration',
  },
  {
    id: 30,
    title: 'Romantic Couple Silhouettes',
    url: 'https://images.unsplash.com/photo-1615966650071-855b15f29ad1?auto=format&fit=crop&w=1200&q=80',
    category: 'True Love',
  },
];
